module.exports = __webpack_public_path__ + "static/favicon-snail-e852a73b943809f81a959d0cfb55d275.png";